export const dataDogInit = () => {
	const isProduction = process.env.REACT_APP_ENV === 'production'
	if (isProduction) {
		import('@datadog/browser-logs').then(({ datadogLogs }) => {
			datadogLogs.init({
				clientToken: 'pub59e7ebe36c0f4a1dbc39a1ac18dcdce9',
				site: 'datadoghq.com',
				service: 'patients',
				forwardErrorsToLogs: true,
				sampleRate: 100,
				env: 'prod',
			})
			console.log(
				'%c DATADOG LOG INITIATE! ',
				'background: #8dc63f; color: #fff',
			)
		})
	} else {
		console.log('%c DATADOG NOT INITIATE! ', 'background: #bf3434; color: #fff')
	}
}
